import React from 'react';

/**
 * Reports Page Component
 * 
 * Reports and data export page
 * 
 * @returns {JSX.Element} Reports page component
 */
export const Reports: React.FC = () => {
  return (
    <div className="p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-agentic-text-primary mb-2">
          Reports
        </h1>
        <p className="text-agentic-text-secondary">
          Generate and download reports for your platform data
        </p>
      </div>

      {/* Report Generation */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        <div className="bg-white rounded-lg shadow-sm border border-agentic-gray-200 p-6">
          <h2 className="text-xl font-semibold text-agentic-text-primary mb-4">
            Generate Report
          </h2>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-agentic-text-primary mb-2">
                Report Type
              </label>
              <select className="w-full px-4 py-3 border border-agentic-gray-300 rounded-md focus:border-agentic-primary-blue focus:ring-1 focus:ring-agentic-primary-blue">
                <option>User Activity Report</option>
                <option>Performance Report</option>
                <option>Financial Report</option>
                <option>System Health Report</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-agentic-text-primary mb-2">
                Date Range
              </label>
              <select className="w-full px-4 py-3 border border-agentic-gray-300 rounded-md focus:border-agentic-primary-blue focus:ring-1 focus:ring-agentic-primary-blue">
                <option>Last 7 days</option>
                <option>Last 30 days</option>
                <option>Last 90 days</option>
                <option>Custom range</option>
              </select>
            </div>
            <button className="w-full bg-agentic-primary-blue text-white px-6 py-3 rounded-md hover:bg-agentic-primary-blue-dark transition-colors duration-300">
              Generate Report
            </button>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-sm border border-agentic-gray-200 p-6">
          <h2 className="text-xl font-semibold text-agentic-text-primary mb-4">
            Recent Reports
          </h2>
          <div className="space-y-3">
            <div className="flex items-center justify-between p-3 bg-agentic-gray-50 rounded-lg">
              <div>
                <p className="text-sm font-medium text-agentic-text-primary">User Activity Report</p>
                <p className="text-xs text-agentic-text-secondary">Generated 2 hours ago</p>
              </div>
              <button className="text-agentic-primary-blue hover:text-agentic-primary-blue-dark text-sm font-medium">
                Download
              </button>
            </div>
            <div className="flex items-center justify-between p-3 bg-agentic-gray-50 rounded-lg">
              <div>
                <p className="text-sm font-medium text-agentic-text-primary">Performance Report</p>
                <p className="text-xs text-agentic-text-secondary">Generated 1 day ago</p>
              </div>
              <button className="text-agentic-primary-blue hover:text-agentic-primary-blue-dark text-sm font-medium">
                Download
              </button>
            </div>
            <div className="flex items-center justify-between p-3 bg-agentic-gray-50 rounded-lg">
              <div>
                <p className="text-sm font-medium text-agentic-text-primary">Financial Report</p>
                <p className="text-xs text-agentic-text-secondary">Generated 3 days ago</p>
              </div>
              <button className="text-agentic-primary-blue hover:text-agentic-primary-blue-dark text-sm font-medium">
                Download
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Report Templates */}
      <div className="bg-white rounded-lg shadow-sm border border-agentic-gray-200 p-6">
        <h2 className="text-xl font-semibold text-agentic-text-primary mb-4">
          Report Templates
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="p-4 border border-agentic-gray-200 rounded-lg hover:border-agentic-primary-blue transition-colors duration-300">
            <h3 className="font-medium text-agentic-text-primary mb-2">Monthly Summary</h3>
            <p className="text-sm text-agentic-text-secondary mb-3">Comprehensive monthly overview</p>
            <button className="text-agentic-primary-blue hover:text-agentic-primary-blue-dark text-sm font-medium">
              Use Template
            </button>
          </div>
          <div className="p-4 border border-agentic-gray-200 rounded-lg hover:border-agentic-primary-blue transition-colors duration-300">
            <h3 className="font-medium text-agentic-text-primary mb-2">Quarterly Review</h3>
            <p className="text-sm text-agentic-text-secondary mb-3">Quarterly performance analysis</p>
            <button className="text-agentic-primary-blue hover:text-agentic-primary-blue-dark text-sm font-medium">
              Use Template
            </button>
          </div>
          <div className="p-4 border border-agentic-gray-200 rounded-lg hover:border-agentic-primary-blue transition-colors duration-300">
            <h3 className="font-medium text-agentic-text-primary mb-2">Custom Report</h3>
            <p className="text-sm text-agentic-text-secondary mb-3">Build your own report</p>
            <button className="text-agentic-primary-blue hover:text-agentic-primary-blue-dark text-sm font-medium">
              Create New
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

